import addPageMetaDataTracking from '@ri-digital/web-data-layer/dist/events/AddPageMetaDataTracking';

import config from '../../../../config/default.json';
import addToDataLayer from '../../../helpers/addToDataLayer';
import getMainSiteLocation from '../../../helpers/getMainSiteLocation';
import { userProps } from '../../../lib/reactives';

const getShippingPassStatus = (shippingPass) => {
  if (!shippingPass) return 'not-eligible';

  const { product, active } = shippingPass;
  if (!product) return 'not-eligible';
  if (active) return 'active';

  return 'eligible';
};

export const getShippingPassStatusConfirmationPage = (
  deliveryPassInfo,
  hasDeliveryPass,
) => {
  if (!deliveryPassInfo || Object.keys(deliveryPassInfo).length === 0) {
    return 'not-eligible';
  }
  if (deliveryPassInfo.customerHasActiveSubscription || hasDeliveryPass) {
    return 'active';
  }
  if (deliveryPassInfo.customerEligible) {
    return 'eligible';
  }

  return 'not-eligible';
};

const pageMetaData = (
  type = 'checkout',
  name = 'checkout',
  deliveryPassInfo,
  hasDeliveryPass,
) => {
  const { origin } = window.location;

  const isLoggedIn = () => {
    const { userId, isGuest } = userProps();
    return isGuest ? false : Boolean(userId);
  };
  const {
    userId,
    userAge,
    totalOrders,
    shippingPass,
    country,
    currency,
    isGuest,
  } = userProps();

  const envMapped = getMainSiteLocation(config, origin);

  if (!userId && !isGuest) return;

  const data = {
    name: `checkout.${name}`,
    contentGroup: 'checkout',
    type,
    countryCode: country,
    currencyCode: currency,
    checkoutAppVersion: `v2 ${tagVersionNum ?? 'local'}`,
    isUserLoggedIn: isLoggedIn(),
    userId,
    userAge: userAge && userAge?.toString(),
    userHasTransacted: !!(totalOrders && totalOrders > 0),
    shippingPassStatus:
      name === 'confirmation'
        ? getShippingPassStatusConfirmationPage(
            deliveryPassInfo,
            hasDeliveryPass,
          )
        : getShippingPassStatus(shippingPass),
    envMap: envMapped?.env,
  };

  const formattedData = addPageMetaDataTracking(data);

  addToDataLayer('pageMetaData', formattedData);
};

export default pageMetaData;
